module.exports = __webpack_public_path__ + "img/ryzs2.1999a16c.jpg";